<div class="toast" [ngClass]="getToastType()" *ngIf="toast">
  <div *ngIf="toast.showClose" class="close-button" (click)="close($event)"></div>
  <div *ngIf="toast.title || toast.message" class="toast-text">
    <span *ngIf="toast.title" class="toast-title" [innerHTML]="toast.title | safeHtml"></span>
    <br *ngIf="toast.title && toast.message" />
    <span *ngIf="toast.message" class="toast-msg" [innerHtml]="toast.message | safeHtml"></span>
  </div>
</div>
